// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  dashboard: getIcon('ic_dashboard'),
  question: getIcon('ic_question'),
  users: getIcon('ic_users'),
  report: getIcon('ic_report'),
  money: getIcon('ic_money'),
  gift: getIcon('ic_gift'),
  game: getIcon('ic_game'),
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'مسابقات',
    items: [
      {
        title: 'لیست کوییز',
        icon: ICONS.game,
        path: PATH_DASHBOARD.competition.list,
      },
    ],
  },
  {
    subheader: 'مخزن',
    items: [
      {
        title: 'لیست سوالات',
        path: PATH_DASHBOARD.bank.questions,
        icon: ICONS.question,
      },
    ],
  },
  // {
  //   subheader: 'جوایز',
  //   items: [

  //   ],
  // },
  {
    subheader: 'کاربران',
    items: [
      {
        title: 'لیست کاربران',
        path: PATH_DASHBOARD.users.participants,
        icon: ICONS.users,
      },
    ],
  },
  // {
  //   subheader: 'گزارشات',
  //   items: [
  //     {
  //       title: 'لیست جوایز مسابقات',
  //       path: PATH_DASHBOARD.reward.list,
  //       icon: ICONS.gift,
  //     },
  //     {
  //       title: 'آرشیو مسابقه',
  //       path: PATH_DASHBOARD.report.competitions,
  //       icon: ICONS.report,
  //     },
  //     {
  //       title: 'آنالیز شرکت کنندگان',
  //       path: PATH_DASHBOARD.report.users,
  //       icon: ICONS.report,
  //     },
  //     {
  //       title: 'آنالیز سوالات',
  //       path: PATH_DASHBOARD.report.questions,
  //       icon: ICONS.report,
  //     },
  //   ],
  // },
  {
    subheader: 'حسابداری',
    items: [
      {
        title: 'لیست تراکنش ها',
        path: PATH_DASHBOARD.accountant.transactionList,
        icon: ICONS.money,
      },
      // {
      //   title: 'درخواست برداشت وجه',
      //   path: PATH_DASHBOARD.accountant.withdrawRequest,
      //   icon: ICONS.money,
      // },
    ],
  },
  {
    subheader: 'فروشگاه',
    items: [
      {
        title: 'فهرست',
        path: PATH_DASHBOARD.shop.list,
        icon: ICONS.money,
      },
    ],
  },
  // {
  //   subheader: 'هدایا',
  //   items: [
  //     {
  //       title: 'لیست',
  //       path: PATH_DASHBOARD.giveaways.list,
  //       icon: ICONS.gift,
  //     },
  //   ],
  // },
];

export default sidebarConfig;
